import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {SessionStore} from '../../../session.store';
import {ParticipantRole, ParticipantState} from '@paperlessio/sdk/api/models';
import {toSignal} from '@angular/core/rxjs-interop';
import {param} from '@paperlessio/sdk/util/signals';

@Component({
  selector: 'app-other-actions',
  templateUrl: './other-actions.component.html',
  styleUrls: ['./other-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
}) export class OtherActionsComponent {
  private sessionStore = inject(SessionStore);

  tosApproved = toSignal(this.sessionStore.tosApproved);
  submissionMetaInformation = toSignal(this.sessionStore.submissionMetaInformation);

  token = param('token');

  submittable = computed(() => this.submissionMetaInformation().submittable);
  participantIsViewer = computed(() => this.submissionMetaInformation().participant.role === ParticipantRole.viewer);

  invalidParticipantState = computed(() => {
    const smi = this.submissionMetaInformation();
    return [ParticipantState.disabled, ParticipantState.completed, ParticipantState.skipped].includes(smi.participant.state);
  });

  showDeclineButton = computed(() => {
    const smi = this.submissionMetaInformation();
    return [ParticipantRole.approver, ParticipantRole.default].includes(smi.participant.role);
  });
}
